/**
 * Trust — Layout route for the AI platform audit module.
 *
 * Mission: audit and prove compliance of the ArgusAI platform itself.
 * NOT a generic GRC platform (that's what Drata/Vanta are for).
 *
 * The 8 tabs answer 8 distinct audit questions:
 *  - Overview           "Is my AI platform healthy and being used properly?"
 *  - Activity Trail     "What did [user/agent/workflow] do?"
 *  - Violations         "What blocks happened? Are there patterns?"
 *  - Data Flows         "Where is data going? Is it approved?"
 *  - AI Systems         "What AI is running? What are its safety metrics?"
 *  - Frameworks         "How do our controls map to compliance frameworks?"
 *  - Evidence           "Show me evidence I can hand to an auditor"
 *  - Audit Log          "Show me the tamper-evident hash chain"
 */

import { createFileRoute, Outlet, useLocation } from '@tanstack/react-router';
import { ContentHeader } from '@/components/content-header';
import {
  LayoutDashboard, ScrollText, ShieldAlert, Network, Bot,
  ShieldCheck, FolderArchive, Hash,
} from 'lucide-react';

export const Route = createFileRoute('/trust')({
  component: TrustLayout,
});

const TRUST_TABS = [
  { label: 'Overview',        path: '/trust',             icon: LayoutDashboard },
  { label: 'Activity Trail',  path: '/trust/activity',    icon: ScrollText },
  { label: 'Violations',      path: '/trust/violations',  icon: ShieldAlert },
  { label: 'Data Flows',      path: '/trust/data-flows',  icon: Network },
  { label: 'AI Systems',      path: '/trust/ai-systems',  icon: Bot },
  { label: 'Frameworks',      path: '/trust/frameworks',  icon: ShieldCheck },
  { label: 'Evidence',        path: '/trust/evidence',    icon: FolderArchive },
  { label: 'Audit Log',       path: '/trust/audit',       icon: Hash },
];

function TrustLayout() {
  const location = useLocation();
  // Hide tabs on detail routes like /trust/frameworks/cmmc_l2
  const showTabs = TRUST_TABS.some(t => t.path === location.pathname || location.pathname === t.path + '/');

  return (
    <div className="flex flex-col h-full">
      {showTabs && <ContentHeader title="Trust" tabs={TRUST_TABS} />}
      <div className="flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
}
